<template>
  <TransitionGroup name="fade">
    <slot></slot>
  </TransitionGroup>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "TransitionBlock",
  props: {
    time: String
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active,
.fade-move {
  transition: all 2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
